import BULK_INVITE_VIEW from "./invitationList";

export default BULK_INVITE_VIEW;
